import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import GhostChat from "./components/GhostChat";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import TimeshareOPC from "./pages/TimeshareOPC";
import WebDesign from "./pages/WebDesign";
import LeadGeneration from "./pages/LeadGeneration";
import Partner from "./pages/Partner";
import Portfolio from "./pages/Portfolio";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App min-h-screen bg-[#FAFAFA]">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/timeshare-opc" element={<TimeshareOPC />} />
            <Route path="/web-design" element={<WebDesign />} />
            <Route path="/lead-generation" element={<LeadGeneration />} />
            <Route path="/partner" element={<Partner />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <GhostChat />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
